export const copyFinder = value => JSON.parse(JSON.stringify(value || {}));

// Only send fields actually edited by a section. Another section may have
// changed in the same Vue render tick; its newer values must not be replaced.
export function finderChanges(before, after, prefix = []) {
  return Object.keys(after || {}).reduce((changes, key) => {
    const value = after[key];
    const old = before && before[key];
    // Selection arrays replace as a unit: a shorter array must remove the
    // deselected entries too (e.g. USD + GBP -> Todas).
    if (!Array.isArray(value) && value && typeof value === 'object' && old && typeof old === 'object') {
      return changes.concat(finderChanges(old, value, prefix.concat(key)));
    }
    if (JSON.stringify(old) !== JSON.stringify(value)) changes.push({ path: prefix.concat(key), value });
    return changes;
  }, []);
}

export function patchFinder(current, changes) {
  const next = copyFinder(current);
  changes.forEach(({ path, value }) => {
    let target = next;
    path.slice(0, -1).forEach(key => { target = target[key] || (target[key] = {}); });
    target[path[path.length - 1]] = value === undefined ? null : JSON.parse(JSON.stringify(value));
  });
  return next;
}

export function validateFinder(finder) {
  const ranges = [
    ['min_amount', 'max_amount', 'Montante'],
    ['min_entry_distance', 'max_entry_distance', 'Distancia de la entrada'],
    ['min_edad', 'max_edad', 'Edad'],
    ['min_tae_lt', 'max_tae_lt', 'Rentabilidad'],
    ['min_ona', 'max_ona', 'Número de onda']
  ];
  for (const [min, max, label] of ranges) {
    if (finder[min] !== '' && finder[max] !== '' && Number(finder[max]) > 0 && Number(finder[min]) > Number(finder[max])) {
      return `${label}: el límite inferior no puede superar al superior.`;
    }
  }
  return '';
}
